// Dropdown options shared by the on-page FilterBar on master screens.

// Partner status codes (LMBP, franchise, courier hub)
export const PARTNER_STATUS_OPTIONS = [
  { value: "1", label: "Active" },
  { value: "4", label: "In-Active" },
  { value: "3", label: "Blocked" },
  { value: "5", label: "Rejected" },
];

// For fetches that take a status list: one pick is stored as ["code"]
export const asStatusList = {
  toValue: (stored) => (Array.isArray(stored) ? stored[0] : stored) || "",
  fromOption: (option) => (option ? [option.value] : []),
};

// Bag statuses, in the order a bag moves through them
export const BAG_STATUS_OPTIONS = [
  { value: "OPEN", label: "Open" },
  { value: "SEALED", label: "Sealed" },
  { value: "NOTIFIED_HUB", label: "Notified Hub" },
  { value: "ACCEPTED_BY_HUB", label: "Accepted by Hub" },
  { value: "OPENED_AT_HUB", label: "Opened at Hub" },
  { value: "ALLOCATED_TO_DELIVERY_BOY", label: "Allocated to Delivery Boy" },
  { value: "HANDED_OVER_TO_DELIVERY_BOY", label: "Handed Over to Delivery Boy" },
];

// Ledger debit / credit, as stored (drCr)
export const DR_CR_OPTIONS = [
  { value: "DR", label: "Debit (DR)" },
  { value: "CR", label: "Credit (CR)" },
];
